import { render } from "./EcosystemShowcase.vue?vue&type=template&id=67cb02af&scoped=true"
import script from "./EcosystemShowcase.vue?vue&type=script&lang=js"
export * from "./EcosystemShowcase.vue?vue&type=script&lang=js"

import "./EcosystemShowcase.vue?vue&type=style&index=0&id=67cb02af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cb02af"]])

export default __exports__